import { useContext } from "react";
import GlobalContext from "../app/GlobalContext/GlobalContext.js";
export default function () {
    return useContext(GlobalContext);
}
